import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, CheckCircle } from 'lucide-react';
import api from '../utils/api';
import toast from 'react-hot-toast';

function AuthLayout({ children, title, subtitle }) {
  return (
    <div style={{
      minHeight: '100vh', paddingTop: 68, display: 'flex', alignItems: 'center',
      background: `radial-gradient(ellipse at 30% 50%, rgba(0,200,255,0.06) 0%, transparent 55%),
                   radial-gradient(ellipse at 70% 30%, rgba(168,85,247,0.06) 0%, transparent 55%),
                   var(--ac-dark)`,
    }}>
      <div className="container" style={{ display: 'flex', justifyContent: 'center', padding: '2rem 1.5rem' }}>
        <div style={{ width: '100%', maxWidth: 460, background: 'var(--ac-card)', border: '1px solid var(--ac-border)', borderRadius: 'var(--radius-xl)', padding: '2.5rem', boxShadow: 'var(--shadow-card)' }}>
          <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '2rem' }}>
            <img src="/logo.png" alt="AlteraCode" style={{ height: 72, width: 'auto', objectFit: 'contain' }} />
          </div>
          <h1 style={{ fontSize: 24, fontWeight: 800, color: 'var(--ac-white)', marginBottom: 6, textAlign: 'center' }}>{title}</h1>
          <p style={{ fontSize: 14, color: 'var(--ac-muted)', textAlign: 'center', marginBottom: '2rem' }}>{subtitle}</p>
          {children}
        </div>
      </div>
    </div>
  );
}

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post('/auth/forgot-password', { email });
      setSent(true);
    } catch (err) {
      // Show success state even on error to avoid email enumeration
      setSent(true);
    } finally {
      setLoading(false);
    }
  };

  if (sent) return (
    <AuthLayout title="Check Your Email" subtitle="A reset link is on its way">
      <div style={{ textAlign: 'center', padding: '1rem 0' }}>
        <CheckCircle size={56} color="var(--ac-green)" style={{ marginBottom: '1rem' }} />
        <p style={{ color: 'var(--ac-text)', lineHeight: 1.7, marginBottom: '1.5rem' }}>
          If an account exists for <strong style={{ color: 'var(--ac-white)' }}>{email}</strong>, you'll receive a password reset link shortly.
        </p>
        <Link to="/login" className="btn btn-primary" style={{ justifyContent: 'center', width: '100%' }}>
          <ArrowLeft size={16} /> Back to Login
        </Link>
      </div>
    </AuthLayout>
  );

  return (
    <AuthLayout title="Forgot Password?" subtitle="Enter your email and we'll send you a reset link">
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label className="form-label">Email Address</label>
          <div style={{ position: 'relative' }}>
            <Mail size={16} color="var(--ac-muted)" style={{ position: 'absolute', left: 13, top: '50%', transform: 'translateY(-50%)' }} />
            <input
              className="form-input"
              type="email"
              placeholder="you@email.com"
              value={email}
              onChange={e => setEmail(e.target.value)}
              required
              autoComplete="email"
              style={{ paddingLeft: 40 }}
            />
          </div>
        </div>
        <button
          type="submit"
          className="btn btn-primary"
          style={{ width: '100%', justifyContent: 'center', height: 46, marginBottom: '1rem' }}
          disabled={loading}
        >
          {loading ? 'Sending...' : 'Send Reset Link'}
        </button>
      </form>
      <p style={{ fontSize: 14, color: 'var(--ac-muted)', textAlign: 'center' }}>
        <Link to="/login" style={{ color: 'var(--ac-cyan)', textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 5 }}>
          <ArrowLeft size={14} /> Back to Login
        </Link>
      </p>
    </AuthLayout>
  );
}
